import { arrayMoveImmutable } from 'array-move';
import { AnimatePresence } from 'framer-motion';
import { Fragment, PureComponent, ReactNode, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import bookAppointment, { RequestResponse } from '../api/bookAppointment';
import { AppointmentsResponse, fetchTodayQueue } from '../api/fetchAppointmentsV2';
import fetchPtMedHistory from '../api/fetchPtMedHistory';
import { Template } from '../api/getAttachmentTemplatesForDoctor';
import getPostsByPatientId from '../api/getPostsByPatientId';
import pushPtMedHistory from '../api/pushPtMedHistory';
import pushPxDraft from '../api/pushPxDraft';
import { createBETool } from '../api/pushVisit';
import { EditPatientWrapperDialog } from '../components/common/EditPatientDialogWrapper';
import GoToPadConfirmation from '../components/common/GotoPadConfirmation';
import NavBar from '../components/common/NavBar';
import AttachmentHistoryBt from '../components/prescriptionPad/leftPanel/AttachMentHistoryBtn';
import CreateVisitBt from '../components/prescriptionPad/leftPanel/CreateNewVisit';
import MedicalCertificatesBt from '../components/prescriptionPad/leftPanel/MedicalCertificatesBt';
import MedicalHistoryBt from '../components/prescriptionPad/leftPanel/MedicalHistoryBt';
import MedicalRecordsBt from '../components/prescriptionPad/leftPanel/MedicalRecordsBt';
import OrdersBt from '../components/prescriptionPad/leftPanel/OrdersBt';
import PastSaBt from '../components/prescriptionPad/leftPanel/PastSaBt';
import PastVisitsBt from '../components/prescriptionPad/leftPanel/PastVisitsBt';
import PastVitalsBt from '../components/prescriptionPad/leftPanel/PastVitalsBt';
import PatientMedicalSummary from '../components/prescriptionPad/leftPanel/PatientMedicalSummary';
import PatientOverviewBt from '../components/prescriptionPad/leftPanel/PatientOverviewBt';
import PatientPersonalInfoCard from '../components/prescriptionPad/leftPanel/PatientPersonalProfile';
import ReceiptsBt from '../components/prescriptionPad/leftPanel/ReceiptsBt';
import PatientDetailsPatientOverview from '../components/prescriptionPad/rightPanel/workspace/PatientDetailsPatientOverview';
import { MedicalHistoryPanelComponent } from '../components/prescriptionPad/rightPanel/workspace/padV2/MedicalHistoryCardPadV2';
import AttachmentPatientHistory from '../components/prescriptionPad/rightPanel/workspace/padV2/PatientAttachmentHistory';
import {
    GO_TO_APPOINTMENTS,
    GO_TO_BORROW_PRESCRIPTION_WITH_ID,
    GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID,
    GO_TO_PATIENTS_DETAILS,
    PtDetailsProps,
} from '../routes/paths';
import { Actions } from '../store/actions';
import {
    NewPatient as AddPatientNewPatient,
    WithBEPatient,
    addPatient,
    toLocalPatient,
    toLocalPatientFromTrinity,
} from '../store/actions/app';
import { setEditPatient } from '../store/actions/session';
import {
    MISC_KEYS,
    getDoc,
    getDocIds,
    getDoctorProfile,
    getDoctorSelectorList,
    getItemFromMisc,
    getPatientByLocalId,
    getPrescriptionById,
    getSelectedClinicId,
    getVisitByIds,
    upsertPatient,
    upsertPrescription,
} from '../store/idbHandler';
import { GlobalState } from '../store/reducers';
import { isMHFilled } from '../store/selectors/prescriptionPad';
import {
    LifestyleHabits,
    MEDICAL_HISTORY_CATEGORY,
    MHC,
    MHItem2,
    PatientMedicalCondition,
} from '../store/types/medicalHistory';
import { Patient } from '../store/types/patient';
import { Doctor, LabVitalEntity } from '../store/types/prescription';
import {
    cloneAndDelete,
    cloneAndUpsert,
    mergeVitals,
    toBookAppointmentPatient,
} from '../store/utils';
import { track } from '../tracking';
import {
    getAppointmentAction,
    getAppointmentActionTextForAction,
    isCNRE,
    onAppointmentAction,
} from './AppointmentUtils';
import { AP, APWithOptionalpatient } from './Appointments';
import { BorrowPrescriptionLocationState, computeFollowUp } from './BorrowPrescription';
import LinkABHAV2 from './LinkAbhav2';
import TreatmentsBt from '../components/prescriptionPad/leftPanel/TreatmentsBt';
import MedicalCertificatesRightPanel from './MedicalCertificatesRightPanel';
import MedicalRecordsRightPanel from './MedicalRecordsRightPanel';
import MergePatienttPtDetails from './MergePatienttPtDetails';
import OrdersRightPanel from './OrdersRightPanel';
import SelfAssessmentRightPanel from './PastSaRightPanel';
import PastVisitsRightPanel from './PastVisitsRightPanel';
import PastVitalsRightPanel from './PastVitalsRightPanel';
import ReceiptsRightPanel from './ReceiptsRightPanel';
import { captureError } from './captureError';
import { onCreateVisit } from './utils';
import PatientTreatmentsContainer from '../components/prescriptionPad/rightPanel/workspace/PatientTreatmentsContainer';
import { ACTIVE_TAB } from './MedicalRecordsSwitchPanel';
import DentalTreatmentsBt from '../components/prescriptionPad/leftPanel/DentalTreatmentsBt';
import TreatmentPlanRightPanel from '../components/prescriptionPad/rightPanel/workspace/TreatmentPlan/TreatmentPlanRightPanel';
import { getGenieSetting, getIsTreatmentPlanEnabled } from '../store/selectors/session';
import MedicalRecordsTable from './MedicalRecordsTable';
import ABDM from '../components/mobilenumber/ABDMEnroll';
import ABHAConsentBtn from '../components/prescriptionPad/leftPanel/AbhaConsentBtn';
import { MedicalHistoryConfig, SREV2 } from '../api/pushGenie';
import { DEFAULT_MEDICAL_HISTORY_CONFIG_VALUES } from '../constants';
import { getMyIdWithBackwardCompatibility } from '../api/mactiveid';
import { getAclViewClassName } from '../restrictions/utils';
import fetchPatientFromTrinity from '../api/fetchPatientFromTrinity';
import { getMActiveId } from '../store/localstorage';
import { PtDir } from '../api/fetchMyGenie';
import fetchPatientDirByDocOid from '../api/fetchPatientDirByDocOid';

export interface StaticContext {
    statusCode?: number | undefined;
}

interface Props
    extends RouteComponentProps<
        PtDetailsProps,
        StaticContext,
        { activeTab?: ACTIVE_TAB; intoPxId?: string }
    > {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    isABDM: boolean;
}

type State = {
    patient?: Patient;
    ptMedicalHistory: MHC;
    medHistoryFetchState: 'loading' | 'success' | 'error';
    medHistorySaveState: 'loading' | 'success' | 'changed' | undefined;
    ptMedicalCondition: PatientMedicalCondition[];
    ptLifeStyleHabits: LifestyleHabits[];
    medicalRecordsCount?: number;
    todayAppointments?: APWithOptionalpatient[];
    isApptApiLoading: boolean;
    isAbhaEnable: boolean;
    mergedPts: Patient[];
    mrSmartVitalPxid?: string;
    isGotoPadConfirmationVisible: boolean;
    bookedAppt?: AP;
    medicalHistoryConfigData: MedicalHistoryConfig;
    doctor?: Doctor;
};

type SelectedRoute =
    | 'visit'
    | 'medical-history'
    | 'medical-records'
    | 'past-vitals'
    | 'orders'
    | 'receipts'
    | 'medical-certificates'
    | 'past-sa'
    | 'patient-overview'
    | 'treatments'
    | 'dental-treatments'
    | 'abha-requests';
class PatientDetailsComponent extends PureComponent<Props, State> {
    initialState: State = {
        patient: undefined,
        ptMedicalHistory: {},
        medHistoryFetchState: 'loading',
        medHistorySaveState: undefined,
        ptMedicalCondition: [],
        ptLifeStyleHabits: [],
        medicalRecordsCount: undefined,
        isApptApiLoading: true,
        isAbhaEnable: false,
        mergedPts: [],
        mrSmartVitalPxid: undefined,
        isGotoPadConfirmationVisible: false,
        bookedAppt: undefined,
        medicalHistoryConfigData: DEFAULT_MEDICAL_HISTORY_CONFIG_VALUES,
    };
    state: State = this.initialState;
    ptVisitId?: string;
    ptVisitcId?: string;

    componentWillUnmount(): void {
        window.onafterprint = () => {
            return;
        };
    }

    updatePt = async (): Promise<void> => {
        const p = await getPatientByLocalId(this.props.match.params.plId);

        let mergedPts: Patient[] = [];

        if (p) {
            if (p['link'] && p['link'].length !== 0) {
                mergedPts = await this.getMergedPts(p['link']);
            }

            this.setState({
                patient: p,
                mergedPts,
            });
        }
    };

    setPatient = async (patient?: Patient): Promise<void> => {
        if (patient && patient?.localId !== this.props.match.params.plId) {
            this.props.history.replace(GO_TO_PATIENTS_DETAILS(patient.localId, 'visit'));
            return;
        }

        this.updatePt();

        // check with BE
        try {
            const settings = await getItemFromMisc<PtDir>(getMActiveId() || '', 'ptDir');

            const res = await fetchPatientDirByDocOid(
                !settings.userLevel ? ['all'] : getDocIds(),
                this.props.match.params.plId,
            );

            const pts = res.data?.filter((item) => item.id === this.props.match.params.plId);

            if (res.status !== 'success' || !res.data || pts?.length !== 1) {
                console.error('No data found');
                alert('Failed to fetch latest details of the patient  [6]');
                this.props.history.goBack();
                return;
            }

            await Promise.all(res.data.map((ptItem) => upsertPatient(toLocalPatient(ptItem))));
            this.updatePt();

            // const res = await fetchPatientFromTrinity(this.props.match.params.plId);
            // if (!res.oid) {
            //     throw new Error('No patient found');
            // }

            // if (res.extras?.link?.length) {
            //     const mergedPtsPromises = res.extras?.link?.map((t: string) =>
            //         fetchPatientFromTrinity(t),
            //     );
            //     Promise.all(mergedPtsPromises)

            //         // Only giving error in the local dev server
            //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //         // @ts-ignore

            //         .then((patients) => patients.map(toLocalPatientFromTrinity).map(upsertPatient))
            //         .catch((e) => {
            //             console.error(e);
            //             captureError(e as Error);
            //             alert('Failed to fetch latest details of the patient  [6.1]');
            //             track('ERROR', {
            //                 on: 'PatientDetails#fetchPatientFromTrinity',
            //                 what: 'Failed to fetch merged patients',
            //                 pids: res.extras?.link?.toString(),
            //             });
            //         });
            // }

            // await upsertPatient(toLocalPatientFromTrinity(res));

            // this.updatePt();
            return;
        } catch (e) {
            console.error(e);
            captureError(e as Error);
            alert('Failed to fetch latest details of the patient  [7]');
            console.error('patient not found');
            this.props.history.goBack();
            return;
        }
    };

    fetchTodayAppts = (onComplete?: () => void): void => {
        const selectedClinicId = getSelectedClinicId();
        if (!selectedClinicId) {
            track('ERROR', {
                on: 'PatientDetails#fetchTodayAppts',
                what: 'No clinic selected',
            });
            return;
        }

        fetchTodayQueue(selectedClinicId)
            .then(async (response: AppointmentsResponse) => {
                if (!response.response?.apt) {
                    return;
                }
                const list = response.response.apt
                    .filter((t) => t.patient_oid === this.props.match.params.plId)
                    .filter((t) => !isCNRE(t.status));
                const visitIds = list.map((a) => a.aid);
                const localVisits = (await getVisitByIds(visitIds)) || [];
                const localContextList = list.map((a, index) => ({
                    ...a,
                    isLocalPresnt: localVisits[index] !== undefined,
                    localRxId: localVisits[index]?.prescriptionId,
                }));

                this.setState(
                    {
                        todayAppointments: localContextList,
                        isApptApiLoading: false,
                    },
                    () => onComplete && onComplete(),
                );

                if (localContextList.length > 1) {
                    track('ERROR', {
                        on: 'PatientDetails#fetchTodayAppts',
                        what: 'Found multiple ongoing visits',
                        count: localContextList.length.toString(),
                    });
                }
            })
            .catch((e) => console.log(e));
    };

    onMount = (): void => {
        this.fetchTodayAppts();

        this.fetchPtMedicalHistory();

        this.setPatient();
    };

    componentDidMount = async (): Promise<void> => {
        const urlParams = new URLSearchParams(location.search);
        this.ptVisitId = urlParams.get('aid') || undefined;
        this.ptVisitcId = urlParams.get('cid') || undefined;
        this.onMount();
        this.getMedicalHistoryConfigData();

        const doctorList = getDoctorSelectorList();
        if (doctorList.length === 1) {
            getDoctorProfile(doctorList[0].id).then((doctor) => {
                this.setState({ doctor });
            });
        }
    };

    getMedicalHistoryConfigData = () => {
        const myId = getMyIdWithBackwardCompatibility() || '';
        getItemFromMisc<MedicalHistoryConfig>(myId, MISC_KEYS.medicalHistoryConfig)
            .then((medicalHistoryConfigData) => {
                this.setState({
                    medicalHistoryConfigData: medicalHistoryConfigData,
                });
            })
            .catch(console.error);
    };

    dummyUpdatePatientProfileToRemoveCachedData = async (patient: Patient): Promise<void> => {
        if (!patient) {
            track('ERROR', {
                on: 'dummyUpdatePatientProfileToRemoveCachedData',
                what: 'No patient found',
            });
            return;
        }

        const patientPersonalProfile = patient?.personal;

        const newP: AddPatientNewPatient = {
            name: [patientPersonalProfile?.name?.f, patientPersonalProfile?.name?.l]
                .filter(Boolean)
                .join(' '),
            phoneNumber: patientPersonalProfile?.phone?.n,
            age: patientPersonalProfile?.age,
            gender: patientPersonalProfile?.gender || '',
            formData: patient?.formData,
        };

        const newPatient = {
            ...newP,
            localId: patient.localId,
            oid: patient.id,
        };

        const onSuccess = async (patient: Patient & { apiFailure: boolean; error?: Error }) => {
            this.setPatient(patient);
            this.setState({ isAbhaEnable: false });
            return;
        };

        this.props.dispatch(
            addPatient({
                newPatient,
                sendWelcome: false,
                onSuccess,
            }),
        );

        return;
    };

    componentDidUpdate = (prevProps: Props): void => {
        if (prevProps.match.params.plId !== this.props.match.params.plId) {
            this.setState({ ...this.initialState });
            this.onMount();
        }
    };

    fetchPtMedicalHistory = (): void => {
        fetchPtMedHistory(getDoc()?._id || '', this.props.match.params.plId)
            .then((d) => {
                d.data
                    ? this.setState({
                          ptMedicalHistory: d.data,
                          medHistoryFetchState: 'success',
                          ptMedicalCondition: d.data.patientMedicalConditions || [],
                          ptLifeStyleHabits: d.data.lifestyleHabits || [],
                      })
                    : this.setState({
                          ptMedicalHistory: {},
                          medHistoryFetchState: 'error',
                          ptMedicalCondition: [],
                          ptLifeStyleHabits: [],
                      });
            })
            .catch(() => {
                this.setState({
                    ptMedicalHistory: {},
                    medHistoryFetchState: 'error',
                    ptMedicalCondition: [],
                    ptLifeStyleHabits: [],
                });
            });
    };

    onEdit = async (pxId: string): Promise<void> => {
        const { patient } = this.state;
        if (!patient) {
            return;
        }

        this.props.history.push(GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID(pxId));
    };

    goToVisit = (vId: string): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'visit', vId));
    };

    setMedHistorySaveState = (state?: 'loading' | 'success' | 'changed'): void => {
        this.setState({ medHistorySaveState: state });
    };

    onMedicalHistorySave = (): void => {
        this.setMedHistorySaveState('loading');
        const { plId }: PtDetailsProps = this.props.match.params;
        const { ptMedicalHistory } = this.state;
        if (ptMedicalHistory && plId) {
            pushPtMedHistory(
                getDoc()?._id || '',
                plId,
                {
                    patientMedicalConditions: ptMedicalHistory.patientMedicalConditions,
                    familyHistory: ptMedicalHistory.familyHistory,
                    lifestyleHabits: ptMedicalHistory.lifestyleHabits,
                    recentTravelHistory: ptMedicalHistory.recentTravelHistory,
                    currentMedications: ptMedicalHistory.currentMedications,
                    drugAllergy: ptMedicalHistory.drugAllergy,
                    foodOtherAllergy: ptMedicalHistory.foodOtherAllergy,
                    pastProcedures: ptMedicalHistory.pastProcedures,
                    otherMedicalHistory: ptMedicalHistory.otherMedicalHistory,
                },
                new Date().toISOString(),
            )
                .then(() => {
                    this.fetchPtMedicalHistory();
                    this.setMedHistorySaveState('success');
                })
                .catch(() => alert('Error saving medical history'));
        }
    };

    onMedItemSave = (catId: MEDICAL_HISTORY_CATEGORY, item: MHItem2, index?: number): void => {
        track('MH_ITEMS_SAVE', {
            from: 'pt-details-component',
            catId,
            item: item.id,
            status: item.status,
            name: item.name,
        });

        this.setState({
            ptMedicalHistory: {
                ...this.state.ptMedicalHistory,
                [catId]: cloneAndUpsert(item, this.state.ptMedicalHistory[catId], index),
            },
        });
    };

    onClearMedItem = (): void => {
        this.setState({
            ptMedicalHistory: {},
        });
    };

    onSwapItem = (catId: MEDICAL_HISTORY_CATEGORY, from: number, to: number): void => {
        const t = this.state.ptMedicalHistory[catId];
        if (!t) {
            return;
        }
        this.setState({
            ptMedicalHistory: {
                ...this.state.ptMedicalHistory,
                [catId]: arrayMoveImmutable([...t], from, to).filter((el) => !!el),
            },
        });
    };

    onMedItemDelete = (catId: MEDICAL_HISTORY_CATEGORY, itemId: string): void => {
        track('MH_ITEMS_DELETE', {
            from: 'pt-details-component',
            catId,
            item: itemId,
        });

        this.setState({
            ptMedicalHistory: {
                ...this.state.ptMedicalHistory,
                [catId]: cloneAndDelete(itemId, this.state.ptMedicalHistory[catId]),
            },
        });
    };

    onPxSyncComplete = (p: Patient): void => {
        const { plId, subRoute } = this.props.match.params;
        if (p.id !== plId) {
            if (!p.id) {
                track('ERROR', { on: 'pt id not found even after syncing px on BE' });
                return;
            }

            this.props.history.replace(GO_TO_PATIENTS_DETAILS(p.id || p.localId, subRoute));
        }
    };

    onUseAsTemplate = async (id: string): Promise<void> => {
        const { plId }: PtDetailsProps = this.props.match.params;
        const { todayAppointments } = this.state;

        if (todayAppointments && todayAppointments?.length > 0) {
            const appt = todayAppointments[0];
            const onComplete = (pxId: string) => {
                const s: BorrowPrescriptionLocationState = {
                    intoPxId: pxId,
                };

                this.props.history.push({
                    pathname: GO_TO_BORROW_PRESCRIPTION_WITH_ID(plId, id),
                    state: s,
                });
            };

            await onAppointmentAction(this, appt, getSelectedClinicId() || '', onComplete);
        } else {
            this.props.history.push({ pathname: GO_TO_BORROW_PRESCRIPTION_WITH_ID(plId, id) });
        }
    };

    updatePtDetailsOnSmartVitalCopy = (
        prescriptionId: string | undefined,
        patient: Patient,
        aid?: string,
        t?: LabVitalEntity[],
    ): void => {
        this.fetchTodayAppts(async () => {
            const px = prescriptionId ? await getPrescriptionById(prescriptionId) : undefined;

            this.setState({
                isGotoPadConfirmationVisible: true,
            });

            aid = aid
                ? aid
                : this.state.todayAppointments?.find((ap) => ap.patient_oid === patient.localId)
                      ?.aid;

            if (aid) {
                pushPxDraft(
                    prescriptionId,
                    aid,
                    px
                        ? createBETool(px)
                        : {
                              labVitals: t,
                          },
                );
            }

            if (this.state.todayAppointments && this.state.todayAppointments.length !== 0) {
                this.setState({
                    todayAppointments: this.state.todayAppointments,
                });
            }
        });
    };

    copyToPrescription = async (t: LabVitalEntity[]): Promise<void> => {
        track('COPY_SMART_VITALS_TO_RX', { from: 'medical-records-page' });

        const currAppt =
            this.state.todayAppointments && this.state.todayAppointments.length !== 0
                ? this.state.todayAppointments[0]
                : undefined;

        const clinicId =
            currAppt?.clinic_id ||
            getSelectedClinicId() ||
            getDoc()?.profile.professional.default_clinic ||
            '';

        const patient =
            this.state.patient ?? (await getPatientByLocalId(this.props.match.params.plId));

        if (currAppt && currAppt.aid) {
            if (currAppt.isLocalPresnt) {
                const px = await getPrescriptionById(currAppt.localRxId ?? '');

                const selectedVitals = t;

                const labVitals = selectedVitals
                    ? mergeVitals(selectedVitals, px?.labVitals)
                    : px.labVitals;

                await upsertPrescription({
                    ...px,
                    symptoms: px.symptoms,
                    diagnosis: px.diagnosis,
                    medications: px.medications,
                    labTests: px.labTests,
                    labVitals: labVitals,
                    followup: computeFollowUp(
                        px ? px.date.toISOString() : new Date().toISOString(),
                        px.followup,
                    ),
                    advices: px.advices,
                });

                if (currAppt.localRxId) {
                    pushPxDraft(
                        currAppt.localRxId,
                        currAppt?.aid,
                        px
                            ? createBETool(px)
                            : {
                                  labVitals: t,
                              },
                    );

                    this.setState({
                        isGotoPadConfirmationVisible: true,
                    });
                }
            } else {
                this.updatePtDetailsOnSmartVitalCopy(undefined, patient, currAppt?.aid, t);
            }
        } else {
            WithBEPatient<RequestResponse | void>(patient, (bePt) =>
                bookAppointment({
                    docId: getDoc()?._id || '',
                    channel: 'Walkin',
                    ptOid: bePt.id,
                    cId: clinicId,
                    dateTime: new Date().toISOString(),
                }).then((val) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    this.setState({ bookedAppt: val.appointment });
                    this.updatePtDetailsOnSmartVitalCopy(
                        undefined,
                        patient,
                        val.appointment?.aid,
                        t,
                    );
                }),
            )(this.props.dispatch);
        }
    };

    // start visit (w/o autocopy), create visit (w/o autocopy)
    // resume visit, start visit (autocopy), create visit (autocopy)

    renderRightPanel = (): ReactNode => {
        const { plId, subRoute, subRouteParam }: PtDetailsProps = this.props.match.params;

        const {
            ptMedicalHistory,
            medHistoryFetchState,
            medHistorySaveState,
            patient,
            medicalHistoryConfigData,
        } = this.state;

        const clinicId = getSelectedClinicId() ?? '';
        const health_id = patient?.abha?.id ?? '';
        const ptId = patient?.id ?? plId;

        switch (subRoute) {
            case 'visit':
                return (
                    <PastVisitsRightPanel
                        plId={plId}
                        editPx={this.onEdit}
                        goToVisit={this.goToVisit}
                        vId={subRouteParam}
                        onPxSyncComplete={this.onPxSyncComplete}
                        onUseAsTemplate={this.onUseAsTemplate}
                        key={JSON.stringify(patient)}
                        history={this.props.history}
                    />
                );
            case 'medical-history':
                return medHistoryFetchState === 'loading' ? (
                    <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
                        <div className="pulse">
                            <svg width="16px" height="12px">
                                <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                                <polyline
                                    id="front"
                                    points="1 6 4 6 6 11 10 1 12 6 15 6"
                                ></polyline>
                            </svg>
                        </div>
                    </div>
                ) : (
                    <div className="flex relative col-span-10 overflow-hidden bg-neutral-9 w-full">
                        <MedicalHistoryPanelComponent
                            isMedicalHistorySection={true}
                            onItemsSaveToDb={this.onMedicalHistorySave}
                            onItemSaveInState={this.onMedItemSave}
                            onItemDeleteFromState={this.onMedItemDelete}
                            onClearMedItem={this.onClearMedItem}
                            onSwapItem={this.onSwapItem}
                            medicalHistory={ptMedicalHistory}
                            fetchState={medHistoryFetchState}
                            medHistorySaveState={medHistorySaveState}
                            setMedHistorySaveState={this.setMedHistorySaveState}
                            key={JSON.stringify(patient)}
                            medicalHistoryConfigData={medicalHistoryConfigData}
                            onRefresh={this.getMedicalHistoryConfigData}
                        />
                    </div>
                );
            case 'medical-records':
                return (
                    <MedicalRecordsRightPanel
                        plId={plId}
                        setMedicalRecordsCount={this.setMedicalRecordsCount}
                        key={JSON.stringify(patient)}
                        copyToPrescription={this.copyToPrescription}
                        activeTab={this.props.location?.state?.activeTab}
                        hideCopyToPrescription
                    />
                );
            case 'abha-requests':
                return this.props.isABDM ? (
                    <MedicalRecordsTable clinicId={clinicId} health_id={health_id} ptId={ptId} />
                ) : (
                    <div className="overflow-auto h-full w-full">
                        <ABDM />
                    </div>
                );
            case 'past-vitals':
                return <PastVitalsRightPanel plId={plId} key={JSON.stringify(patient)} />;
            case 'patient-overview':
                return (
                    <PatientDetailsPatientOverview
                        plId={plId}
                        onUseAsTemplate={this.onUseAsTemplate}
                        key={JSON.stringify(patient)}
                    />
                );
            case 'treatments':
                return <PatientTreatmentsContainer patient_oid={plId} />;
            case 'dental-treatments':
                return (
                    <TreatmentPlanRightPanel
                        patientid={plId}
                        className="col-span-10"
                        patient={patient}
                        docProfile={this.state.doctor}
                    />
                );

            case 'orders':
                return <OrdersRightPanel plId={plId} />;
            case 'receipts':
                return (
                    <ReceiptsRightPanel
                        plId={plId}
                        goToReceipt={this.goToReceipts}
                        receiptId={Number(subRouteParam)}
                        key={JSON.stringify(patient)}
                    />
                );
            case 'medical-certificates':
                return (
                    <MedicalCertificatesRightPanel
                        plId={plId}
                        goToMedicalCertificate={this.goToMedicalCertificates}
                        medicalCertificateId={subRouteParam}
                        key={JSON.stringify(patient)}
                    />
                );
            case 'past-sa':
                return <SelfAssessmentRightPanel plId={plId} key={JSON.stringify(patient)} />;
        }
    };

    setMedicalRecordsCount = (count: number): void => {
        this.setState({
            medicalRecordsCount: count,
        });
    };

    goToMedicalHistory = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'medical-history'));
    };

    goToMedicalRecords = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'medical-records'));
    };

    goToABHAConsentBtn = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'abha-requests'));
    };

    goToPastVitals = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'past-vitals'));
    };

    goToPatientOverview = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'patient-overview'));
    };

    goToTreatments = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'treatments'));
    };

    goToDentalTreatments = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'dental-treatments'));
    };

    goToPastSa = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'past-sa'));
    };

    goToOrders = (): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'orders'));
    };

    goToReceipts = (id?: number): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'receipts', id?.toString() || ''));
    };

    goToMedicalCertificates = (id?: string): void => {
        const { plId }: PtDetailsProps = this.props.match.params;
        this.props.history.replace(GO_TO_PATIENTS_DETAILS(plId, 'medical-certificates', id || ''));
    };

    getSelectedRoute = (subRoute: string): SelectedRoute => {
        switch (subRoute) {
            case 'visit':
                return 'visit';
            case 'medical-records':
                return 'medical-records';
            case 'past-vitals':
                return 'past-vitals';
            case 'receipts':
                return 'receipts';
            case 'medical-certificates':
                return 'medical-certificates';
            case 'past-sa':
                return 'past-sa';
            case 'patient-overview':
                return 'patient-overview';
            case 'treatments':
                return 'treatments';
            case 'dental-treatments':
                return 'dental-treatments';
            case 'orders':
                return 'orders';
            case 'abha-requests':
                return 'abha-requests';
            default:
                return 'medical-history';
        }
    };

    setIsAbha = (state: boolean): void => {
        this.setState({ isAbhaEnable: state });
    };

    getPt = async (): Promise<{
        pt: Patient;
    }> => {
        const pt = await getPatientByLocalId(this.props.match.params.plId);
        return { pt };
    };

    getMergedPts = async (links: string[]): Promise<Patient[]> => {
        return await Promise.all(
            links.map(async (l) => {
                return await getPatientByLocalId(l);
            }),
        );
    };

    renderLeftPanel = (): ReactNode => {
        const { dispatch, history, match, isABDM } = this.props;
        const { subRoute } = match.params;
        const {
            patient,
            ptMedicalCondition,
            ptLifeStyleHabits,
            ptMedicalHistory,
            medicalRecordsCount,
            todayAppointments,
            isAbhaEnable,
            mergedPts,
        } = this.state;

        if (!patient?.personal) {
            return null;
        }

        return (
            <PtDetailsLeftPanel
                onCreateVisit={(docid) =>
                    onCreateVisit({
                        patient,
                        docid,
                        dispatch,
                        history,
                        visitId: this.ptVisitId,
                        cId: this.ptVisitcId,
                    })
                }
                patientMedicalCondition={ptMedicalCondition}
                patientLifeStyleHabits={ptLifeStyleHabits}
                selected={this.getSelectedRoute(subRoute)}
                onPastVisitClick={() => this.goToVisit('')}
                onMedicalHistoryClick={this.goToMedicalHistory}
                goToMedicalRecords={this.goToMedicalRecords}
                goToPastVitals={this.goToPastVitals}
                goToPatientOverview={this.goToPatientOverview}
                goToTreatments={this.goToTreatments}
                goToDentalTreatments={this.goToDentalTreatments}
                goToOrders={this.goToOrders}
                goToReceipts={this.goToReceipts}
                goToMedicalCertificates={this.goToMedicalCertificates}
                goToPastSa={this.goToPastSa}
                isMedHistoryFilled={isMHFilled(ptMedicalHistory)}
                patient={patient}
                medicalRecordsCount={medicalRecordsCount}
                ptTodaysAppts={todayAppointments || []}
                context={this}
                isAbhaEnable={isAbhaEnable}
                setIsAbha={this.setIsAbha}
                ptVisitId={this.ptVisitId}
                getPt={this.getPt}
                mergedPts={mergedPts}
                onMount={this.onMount}
                ptMedicalHistory={ptMedicalHistory}
                dummyUpdatePatientProfileToRemoveCachedData={
                    this.dummyUpdatePatientProfileToRemoveCachedData
                }
                goToABHAConsentBtn={this.goToABHAConsentBtn}
                isABDM={isABDM}
                updatePt={this.updatePt}
            />
        );
    };

    closeGotoPadConfirmation = (): void => {
        this.setState({ isGotoPadConfirmationVisible: false });
    };

    gotoPad = async (): Promise<void> => {
        const patient = this.state.bookedAppt?.patient_oid
            ? toBookAppointmentPatient(
                  await getPatientByLocalId(this.state.bookedAppt?.patient_oid),
              )
            : this.state.patient;

        const appt =
            this.state.todayAppointments && this.state.todayAppointments.length !== 0
                ? this.state.todayAppointments
                : this.state.bookedAppt
                ? [{ ...this.state.bookedAppt, patient: patient }]
                : [];
        const clinicId = appt[0]?.clinic_id || getSelectedClinicId() || '';
        onAppointmentAction(this, appt[0] as AP, clinicId);
    };

    gotoAppt = (clinicId: string): void => {
        this.props.history.replace(GO_TO_APPOINTMENTS(clinicId));
    };

    render(): ReactNode {
        const { patient, isGotoPadConfirmationVisible } = this.state;

        if (!patient) {
            return null;
        }
        const { personal } = patient;
        const { name } = personal;

        const currAppt =
            this.state.todayAppointments && this.state.todayAppointments.length !== 0
                ? this.state.todayAppointments[0]
                : undefined;

        const clinicId =
            currAppt?.clinic_id ||
            this.state.bookedAppt?.clinic_id ||
            getSelectedClinicId() ||
            getDoc()?.profile.professional.default_clinic ||
            '';

        return (
            <Fragment>
                <div className="flex flex-col w-screen h-full font-lato bg-neutral-9">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>EKA - {name.f + ' ' + (name.l ? name.l : '')} Visits</title>
                    </Helmet>
                    <div className="grid grid-cols-prescriptionPadGrid h-full min-w-840 overflow-x-auto">
                        <NavBar />
                        {this.renderLeftPanel()}
                        {this.renderRightPanel()}
                        <AnimatePresence>
                            {isGotoPadConfirmationVisible && (
                                <GoToPadConfirmation
                                    onGotoAppt={() => this.gotoAppt(clinicId)}
                                    onGotoPad={this.gotoPad}
                                    onCancel={this.closeGotoPadConfirmation}
                                    patient={patient}
                                />
                            )}
                        </AnimatePresence>
                    </div>
                </div>
                <EditPatientWrapperDialog
                    onComplete={this.setPatient}
                    fetchMH={this.fetchPtMedicalHistory}
                />
            </Fragment>
        );
    }
}

const PtDetailsLeftPanel: React.FC<{
    patientMedicalCondition: PatientMedicalCondition[];
    patientLifeStyleHabits: LifestyleHabits[];
    selected: SelectedRoute;
    onPastVisitClick: () => void;
    onMedicalHistoryClick: () => void;
    onCreateVisit: (docid: string) => void;
    goToMedicalRecords: () => void;
    goToPastVitals: () => void;
    goToPatientOverview: () => void;
    goToTreatments: () => void;
    goToDentalTreatments: () => void;
    goToPastSa: () => void;
    goToOrders: () => void;
    goToReceipts: () => void;
    goToMedicalCertificates: () => void;
    isMedHistoryFilled: boolean;
    medicalRecordsCount?: number;
    patient?: Patient;
    ptTodaysAppts: APWithOptionalpatient[];
    context: PatientDetailsComponent;
    isAbhaEnable: boolean;
    setIsAbha: (state: boolean) => void;
    ptVisitId?: string;
    getPt: () => Promise<{
        pt: Patient;
    }>;
    mergedPts: Patient[];
    onMount: () => void;
    ptMedicalHistory: MHC | undefined;
    dummyUpdatePatientProfileToRemoveCachedData: (pt: Patient) => void;
    goToABHAConsentBtn: () => void;
    isABDM: boolean;
    updatePt: () => Promise<void>;
}> = ({
    patientMedicalCondition,
    patientLifeStyleHabits,
    selected,
    onPastVisitClick,
    onMedicalHistoryClick,
    isMedHistoryFilled,
    onCreateVisit,
    patient,
    goToMedicalRecords,
    medicalRecordsCount,
    goToPastVitals,
    goToPatientOverview,
    goToTreatments,
    goToDentalTreatments,
    goToPastSa,
    goToOrders,
    goToReceipts,
    goToMedicalCertificates,
    ptTodaysAppts,
    context,
    isAbhaEnable,
    setIsAbha,
    ptVisitId,
    getPt,
    mergedPts,
    onMount,
    ptMedicalHistory,
    dummyUpdatePatientProfileToRemoveCachedData,
    goToABHAConsentBtn,
    isABDM,
    updatePt,
}) => {
    const dispatch = useDispatch();

    const [showAttachmentHistory, setShowAttachmentHistory] = useState(false);
    const [postData, setPostData] = useState<Template[]>([]);
    const isTreatmentPlanEnabled = useSelector(getIsTreatmentPlanEnabled);

    const onPtDetailsEdit = () => {
        dispatch(setEditPatient(patient, ptMedicalHistory));
    };

    const patientPersonalProfile = patient?.personal;

    function onClickAttachmentHistory() {
        getPostsByPatientId(patient?.id || '')
            .then((data) => {
                setPostData(data);
            })
            .catch((err) => {
                console.error(err);
            });

        setShowAttachmentHistory((prev) => !prev);
        track('ATTACHMENT_HISTORY', { patient: patient?.id });
    }
    return (
        <div className="grid h-full grid-flow-row overflow-hidden bg-white border-l grid-rows-leftpanel border-light leftpanel select-none">
            <div className="flex flex-col p-16 border-b border-r border-light">
                <PatientPersonalInfoCard
                    pid={patient?.id}
                    patientPersonalProfile={
                        patientPersonalProfile && {
                            name: [patientPersonalProfile.name.f, patientPersonalProfile.name.l]
                                .filter(Boolean)
                                .join(' '),
                            age: patientPersonalProfile.age,
                            phone: patientPersonalProfile.phone,
                            gender: patientPersonalProfile.gender,
                            onApp: patientPersonalProfile.onApp,
                        }
                    }
                    formData={patient?.formData}
                    onEdit={onPtDetailsEdit}
                    mergedPts={mergedPts}
                    updatePt={updatePt}
                />
                <span className={` ${getAclViewClassName(SREV2.ABHA)}`}>
                    <LinkABHAV2
                        patient={patient}
                        isAbhaModalOpen={isAbhaEnable}
                        setIsAbhaModel={setIsAbha}
                        showAbhaIdPrefix={true}
                        className="my-8"
                        classNameInner="flex px-6 py-4 cursor-pointer items-center gap-2 rounded-8 abha-not-linked w-fitContent"
                        classNameInnerNotLinked="flex p-6 cursor-pointer items-center gap-2 rounded-8 w-fitContent"
                        onAbhaLink={dummyUpdatePatientProfileToRemoveCachedData}
                        cId={getSelectedClinicId() || ''}
                    />
                </span>
                <MergePatienttPtDetails getPt={getPt} onSuccess={onMount} />
                <PatientMedicalSummary
                    onClick={onMedicalHistoryClick}
                    patientMedicalCondition={patientMedicalCondition}
                    patientLifeStyleHabits={patientLifeStyleHabits}
                />
            </div>
            <div className="flex flex-col overflow-auto">
                <PastVisitsBt isSelected={selected === 'visit'} onClick={onPastVisitClick} />
                <div onClick={goToPatientOverview}>
                    <PatientOverviewBt isSelected={selected === 'patient-overview'} />
                </div>
                {isTreatmentPlanEnabled ? (
                    <div onClick={goToDentalTreatments}>
                        <DentalTreatmentsBt isSelected={selected === 'dental-treatments'} />
                    </div>
                ) : (
                    <div onClick={goToTreatments} className={getAclViewClassName(SREV2.TREATMENT)}>
                        <TreatmentsBt isSelected={selected === 'treatments'} />
                    </div>
                )}
                <div onClick={onMedicalHistoryClick}>
                    <MedicalHistoryBt
                        isSelected={selected === 'medical-history'}
                        isFilled={isMedHistoryFilled}
                    />
                </div>
                <div onClick={goToMedicalRecords}>
                    <MedicalRecordsBt
                        isSelected={selected === 'medical-records'}
                        count={medicalRecordsCount}
                    />
                </div>
                {isABDM && patient?.abha?.id && (
                    <div onClick={goToABHAConsentBtn}>
                        <ABHAConsentBtn isSelected={selected === 'abha-requests'} />
                    </div>
                )}
                <div onClick={goToPastVitals}>
                    <PastVitalsBt isSelected={selected === 'past-vitals'} />
                </div>
                <div onClick={goToPastSa} className={getAclViewClassName(SREV2.SA)}>
                    <PastSaBt isSelected={selected === 'past-sa'} />
                </div>
                {ptTodaysAppts.length > 0 ? (
                    <div
                        className={`w-full p-16 ${getAclViewClassName(
                            SREV2.PT_DETAILS_VISIT_ACTIONS,
                        )}`}
                    >
                        <button
                            onClick={() =>
                                onAppointmentAction(
                                    context,
                                    ptTodaysAppts[0],
                                    ptTodaysAppts[0].clinic_id || getSelectedClinicId() || '',
                                )
                            }
                            className="primary-btn px-12 py-8 btn--small w-full relative tooltip-wrapper flex justify-center"
                        >
                            {getAppointmentActionTextForAction(
                                getAppointmentAction(ptTodaysAppts[0]),
                                true,
                            )}
                        </button>
                    </div>
                ) : (
                    <CreateVisitBt onClick={onCreateVisit} ptVisitId={ptVisitId} />
                )}

                <div className="mt-24 space-y-4">
                    <span className="text-12 font-700 px-12">Other Details</span>
                    <OrdersBt onClick={() => goToOrders()} isSelected={selected === 'orders'} />
                    <ReceiptsBt
                        onClick={() => goToReceipts()}
                        isSelected={selected === 'receipts'}
                    />
                    <MedicalCertificatesBt
                        onClick={() => goToMedicalCertificates()}
                        isSelected={selected === 'medical-certificates'}
                    />
                    <AttachmentHistoryBt onClick={onClickAttachmentHistory} />
                </div>
            </div>
            {showAttachmentHistory && (
                <AttachmentPatientHistory
                    postData={postData}
                    onClose={() => setShowAttachmentHistory((prev) => !prev)}
                />
            )}
        </div>
    );
};

export default connect((state: GlobalState) => ({
    isABDM: getGenieSetting(state, 'abdm') as boolean,
}))(PatientDetailsComponent);

export { PatientDetailsComponent };
